export default "__VITE_ASSET__b03d55ca__"